import { FC, useMemo } from 'react';

import DataSourceListItem from './DataSourceListItem';
import { LoadingIndicator } from '@components/LoadingIndicatorMaterial';
import { getSummaryStatus } from '../../utilities/getSummaryStatus';
import { List } from '@3.0/List';
import { useFetchIngestionLogs } from '../../hooks/useIngestionLogSummary.query';
import { IDataSourceItem } from 'Modules/Studio/DataSources/redux/initialState';
import cn from 'utils/cn';
import { EmptyListSection } from '@3.0/index';
import ListError from './components/ListError';
import { useIngestionDataSourceList } from '../../hooks/useIngestionDataSourceList.query';

type TProps = {
  searchTerm: string;
};

const DataSourceList: FC<TProps> = ({ searchTerm }) => {
  const { data: list, isLoading, isError, refetch } = useIngestionDataSourceList(searchTerm);

  const { data: logs } = useFetchIngestionLogs();

  const listWithStatus: (IDataSourceItem & { status?: number; startTime?: Date })[] =
    useMemo(() => {
      return getSummaryStatus(list, logs) || [];
    }, [list, logs]);

  if (isError) {
    return <ListError refetch={refetch} />;
  }

  if (listWithStatus.length === 0 && !isLoading) {
    return (
      <EmptyListSection showRetry={isError} retryFn={refetch} label="No data sources found." />
    );
  }

  return (
    <List
      ulProps={{
        className: cn('tw:flex-1 tw:min-h-0 tw:overflow-y-auto'),
      }}
    >
      <>
        <LoadingIndicator isLoading={isLoading} />
        {listWithStatus.length > 0 &&
          listWithStatus.map((listItem) => (
            <DataSourceListItem key={listItem.id} listItem={listItem} mode="DSViewDataSource" />
          ))}
      </>
    </List>
  );
};

export default DataSourceList;
